<template>
  <v-dialog :value="value" max-width="400" @input="$emit('input', $event)">
    <v-card class="bundle_dialog">
      <v-card-title class="bundle_dialog__title">
        <span>{{ $t("TITLES.qr_code") }}: {{ packageNumber }}</span>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-center py-5">
        <img :src="qr" class="qr-full" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BundleQrDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    qr: {
      type: String,
      default: null,
    },
    packageNumber: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.bundle_dialog {
  &__title {
    background-color: var(--very_light_theme_clr);
    color: var(--theme_text_clr);
    border-bottom: 1px solid var(--border_clr);
  }
}

.qr-full {
  max-width: 100%;
  border-radius: 8px;
}
</style>
